import {SECTIONS} from '../../constants';

import AccordionPage from '@/components/accordion-page';
import {PageContentWrapper} from '@/shared/components';

import './index.css';

const ContactsContent = () => (
  <PageContentWrapper
    className="Contacts"
    loading={false}
    hasResults
    emptyStateTitle="No contacts found!"
  >
    <AccordionPage sections={SECTIONS} />
  </PageContentWrapper>
);

export default ContactsContent;
